module.exports = __webpack_public_path__ + "img/istanbul_img.0ad811eb.png";